import {useTranslation} from 'react-i18next';

import {Box} from '@mui/material';

import {WorkforceProfileWizardLanguagesEditor} from '../WorkforceProfileWizardLanguagesEditor';

import {InfoBanner} from '../../../../../../components/InfoBanner/InfoBanner';
import type {WorkforceProfileExtractedLanguage} from '../../../types/workforceProfileDetailsTypes';

export interface Props {
  rows: WorkforceProfileExtractedLanguage[];
  onRowsChange: (rows: WorkforceProfileExtractedLanguage[]) => void;
}

export const WorkforceProfileWizardLanguagesStep = ({rows, onRowsChange}: Props) => {
  const {t} = useTranslation('translation', {keyPrefix: 'workforceProfilesPage.wizard.sections.languages'});

  return (
    <Box>
      <InfoBanner text={t('guidance')} sx={{mb: 2}} />
      <WorkforceProfileWizardLanguagesEditor rows={rows} onChange={onRowsChange} />
    </Box>
  );
};
